import { RootState } from "store/store";
import { connect } from "react-redux";

import { getActiveStep } from "store/environments/tenants/enroll-tenant/enroll-tenant-selectors";
import { setActiveStepData } from "store/environments/tenants/enroll-tenant/enroll-tenant-actions";

import AutomatedStep from "./AutomatedStep";

const mapStateToProps = (state: RootState) => ({
    activeStep: getActiveStep(state),
});

const AutomatedStepContainer = connect(mapStateToProps, {
    setActiveStepData,
})(AutomatedStep);

export default AutomatedStepContainer;
